import { ReactNode, useState } from "react";
import { AttributeCollection, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode"


import { SiteData } from "../Data/SiteData";
import GetAttributeDefinition, { AttributeTargetType, GetWBComponentByTypename } from "../Data/WBData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import React from "react";
import { WBComponent } from "../WBComponents/WBComponent";




export default function SiteStyleCollectionMenu(
    {title,siteData,collectionList,labelList,componentType,saveFunc,includeAll,saveOnUpdate,header,footer,hideResetButton}:
    {title:string,siteData:SiteData,collectionList:AttributeCollection[],labelList:ReactNode[],componentType:string,saveFunc:Function,includeAll?:boolean,saveOnUpdate?:boolean,header?:ReactNode,footer?:ReactNode,hideResetButton?:boolean}){


    const [tabState,setTabState] = useState(0);
    const [target,changeTarget] = useState(collectionList[0]);
    const [key,setKey] = useState(0); // use a new key each time we reset the buttons
    const updateAtt = (  attribute: string, value: string, targetType: AttributeTargetType) =>{


      if(targetType == AttributeTargetType.Component)
        setNodeComponentAttributeValue(target,attribute,value);
      else
        setNodeStyleAttributeValue(target,ScreenSize.Desktop,attribute,value);
      

      
        siteData.onUpdateStyle();

        if(saveOnUpdate){
          saveFunc();
        }


        }

    const resetTarget = () =>{

        setKey((key+1)%1000);
        target.screenSizeStyleAttributes[ScreenSize.Desktop] = {};
        target.componentAttributes = {};
        siteData.onUpdateStyle();
        siteData.designer?.forceUpdate();
        
    }

    const cDef = GetWBComponentByTypename(componentType);
    const newDef = new WBComponent();
    // newDef.typename = cDef.typename;
    // newDef.hideAdvancedSettings = cDef.hideAdvancedSettings;  
  
   //only include style definitions
    const editList    = (includeAll)?cDef.editList: cDef.editList.filter( (att)=> {return GetAttributeDefinition(att).targetType != AttributeTargetType.Component} );
    const primaryList = (includeAll)?cDef.primaryEditAttributes: cDef.primaryEditAttributes.filter( (att)=> {return GetAttributeDefinition(att).targetType != AttributeTargetType.Component} );


    return(
           <>
              <h2 className="panel-heading">{title}</h2>
              <div className="panel-tabs">

                { labelList.length > 1 &&
                    labelList.map((label,index)=>{

                        return (
                            <button
                            key={index}
                            style={{fontSize:"14px"}}
                            className={
                              "tab-button thick invisible-button " +
                              (tabState == index
                                ? "selected"
                                : "")
                            }
          
                              onClick={() => {setTabState(index);changeTarget(collectionList[index])}}
                          >
                            {label}
                          </button>
                        )
                    })
                }

               
              </div>
              {header}
              <newDef.RenderMenu
                key={key}
                editList={editList}
                primaryList={primaryList}
                layoutNode={target}
                screenSize={ScreenSize.Desktop}
                updateFunc={updateAtt}
                saveFunc={saveFunc}
                showScreenSize={false}
                siteData={siteData}
             

              />
              {footer}
              {!hideResetButton &&<>
              <br></br>
              <div className="global-apply-container">
              <button className="menu-button" onClick={resetTarget}>Reset to Default</button>
              </div>
              </>}
       
            </>
)





}